import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CovoiturageService {


  public apiCovoiturageUrl = "https://api-covoiturage.clem.mobi";

  public apiUrl = "https://api1.clem.mobi";


  constructor(private http: HttpClient) { }

  //header de requete http
  private headers = new HttpHeaders(
    { 'Content-Type': 'application/x-www-form-urlencoded' }
  );



  getBook(): Observable<any> {

    let newStartDate =  new Date()

         var date_start =  newStartDate.getFullYear() + "-" +
         ("0" + (newStartDate.getMonth()+1)).slice(-2) + "-" +
         ("0" + newStartDate.getDate()).slice(-2) + "T" +
         ("0" + newStartDate.getHours()).slice(-2) + ":" +
         ("0" + newStartDate.getMinutes()).slice(-2) + ":" +
         ("0" + newStartDate.getSeconds()).slice(-2)+"Z";


    let tokenString = localStorage.getItem('token_clem_mobi')
    let token = JSON.parse(tokenString)

    let httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }

    return this.http.get<any>(`${this.apiUrl}/api/v2/covoiturage/books?startdate=${date_start}`, httpOptions);

  }

  // patch covoiturage
  updateCovoiturage(id: string, data: any): Observable<any> {

    let tokenString = localStorage.getItem('token_offline') ||  localStorage.getItem('token_clem_mobi')
    let token = JSON.parse(tokenString)

    let httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }


    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    console.log(data)
    return this.http.patch(`${this.apiCovoiturageUrl}/api/covoiturages/${id}`, data, httpOptions)
  }


  // send covoiturage
  sendCovoiturage(data: any): Observable<any> {

    let tokenString = localStorage.getItem('token_offline') ||  localStorage.getItem('token_clem_mobi')
    let token = JSON.parse(tokenString)

    let httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }

    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    console.log(data)
    return this.http.post(`${this.apiCovoiturageUrl}/api/covoiturages`, data, httpOptions)
  }

  // get getListeCovoiturages 
  getListeCovoiturages(page: number, limit: number, emplacement: string,): Observable<any> {

    let tokenString = localStorage.getItem('token_offline') ||  localStorage.getItem('token_clem_mobi')
    let token = JSON.parse(tokenString)

    let httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }


    if (emplacement === null) { emplacement = '' }

    return this.http.get(`${this.apiCovoiturageUrl}/api/covoiturages?page=${page}&limit=${limit}&emplacement=${emplacement}`, httpOptions)
  }

   // get sations guest 
   getListeStationsGuest(): Observable<any> {

    let tokenString = localStorage.getItem('token_offline')
    let token = JSON.parse(tokenString)

    let httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }

    return this.http.get(`${this.apiUrl}/api/v2/guest/stations?type[]=1&_response=compact`, httpOptions)
  }

  // get getListeCovoiturages 
  getCovoiturageById(id: Number): Observable<any> {

    let tokenString = localStorage.getItem('token_offline') ||  localStorage.getItem('token_clem_mobi')
    let token = JSON.parse(tokenString)

    let httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }


    return this.http.get(`${this.apiCovoiturageUrl}/api/covoiturages/${id}`, httpOptions)
  }


  // get user
  getCurrentUser(): Observable<any> {

    let tokenString = localStorage.getItem('token_clem_mobi')
    let token = JSON.parse(tokenString)

    let httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }

    return this.http.get(`${this.apiUrl}/api/v2/users/3?withCommunities=yes`, httpOptions)
  }



}
